import { useNewCode } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { BodyText } from '@calendly/ui/components/typography'
import { textColorSecondary4 } from '@calendly/ui/theme'

import { DropdownFilter } from './dropdown/dropdown_filter'
import { FilterLayout } from './filter_layout'

export const TrackingSelect = ({ params, onApply, useColumnLayout = false }) => {
  const isFilterSettingsEnabled = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled
  const filterCount = params.utm_campaign.length
    + params.utm_source.length
    + params.utm_medium.length
    + params.utm_content.length
    + params.utm_term.length

  const controlText = filterCount === 0
    ? I18n.t(isFilterSettingsEnabled
      ? 'publisher.dashboard.filters.label.all_tracking_ids'
      : 'publisher.dashboard.filters.label.tracking_id_all')
    : I18n.t('publisher.dashboard.filters.label.tracking_id', { count: filterCount })

  const applySelectedValues = (values) => {
    onApply({
      ...params,
      utm_campaign: values?.utm_campaign || [],
      utm_source: values?.utm_source || [],
      utm_medium: values?.utm_medium || [],
      utm_content: values?.utm_content || [],
      utm_term: values?.utm_term || []
    })
  }

  return (
    <FilterLayout
      label={I18n.t(isFilterSettingsEnabled ? 'publisher.dashboard.filters.tracking_ids_label' : 'publisher.dashboard.filters.tracking_id')}
      tooltip={isFilterSettingsEnabled ? (
        <>
          {I18n.t('publisher.dashboard.filters.tracking_ids_pro_tip')}
          {' '}
          <Link
            rel="noopener noreferrer"
            target="_blank"
            underline={false}
            href="https://calendly.com/help/how-to-track-conversions-with-utm-parameters"
          >
            <BodyText inline weight="bold" color={textColorSecondary4}>{I18n.t('publisher.action.learn_more')}</BodyText>
          </Link>
        </>
      ) : undefined}
      useColumnLayout={useColumnLayout}
    >
      <DropdownFilter
        name="tracking"
        params={params}
        showHeader
        showSearchInput
        showSelectedItemGroup
        onApply={applySelectedValues}
        controlText={controlText}
      />
    </FilterLayout>
  )
}
